<template>
  <v-btn
    v-bind="$attrs"
    @click="browseFile"
  >
    <slot />
    <input
      ref="input"
      type="file"
      class="d-none"
      @change="readFile"
    >
  </v-btn>
</template>

<script>
export default {
  name: 'AgUploadFile',
  methods: {
    browseFile () {
      this.$refs.input.click()
    },
    readFile (event) {
      this.$emit('upload', event.target.files[0])
      this.$refs.input.value = ''
    },
  },
}
</script>
